import { Modal } from 'antd'
import styles from './video.module.less'
const Video = (props) => {
  const { src, visible, setVisible } = props
  return (
    <Modal
      visible={visible}
      onCancel={(e) => setVisible(false)}
      wrapClassName="is-mask-modal"
      width="auto"
    >
      <div className={styles.container}>
        <video src={src} className={styles.video} controls></video>
      </div>
    </Modal>
  )
}
export default Video
